import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { AreaComumUnidadeBloqueadaItem } from "../typings";

function useUnidadesBloqueadas(
  params: { page: number; search?: string; limit?: number }
) {

  return useQuery(
    `/v1/bloqueio-reserva`,
    async () => {
      const { data } = await axios.get<PaginateResult<AreaComumUnidadeBloqueadaItem>>(
        `/v1/bloqueio-reserva`,
        {
          params,
        }
      );

      return data;
    }
  );
}

export default useUnidadesBloqueadas;
